import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allPlanograms } from 'app/mocks/data/machines/planograms'

import { api } from 'app/utils/constants'

export const deletePlanogram = http.delete(
    `${process.env.REACT_APP_API_ADDRESS}/${api.machines.planograms.DETAILS}`,
    ({ params }) => {
        const { id } = params

        const planogramFound = allPlanograms.find(
            (planogram) => planogram.id.toString() === id,
        )

        // Not found
        if (!planogramFound) {
            return new HttpResponse(null, {
                status: StatusCodes.NOT_FOUND,
            })
        }

        return new HttpResponse(null, {
            status: StatusCodes.NO_CONTENT,
        })
    },
)
